import React from 'react';
import { Book, Zap, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy pt-12 pb-8 border-t border-white/10" data-id="element-99">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-100">
        {/* CIERRE FINAL - Trust Icons */}
        <div className="grid md:grid-cols-3 gap-8 mb-12 text-center md:text-left border-b border-white/10 pb-12" data-id="element-101">
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-102">
            <Book className="w-8 h-8 text-celeste mb-2" data-id="element-103" />
            <h4 className="font-bold text-lg text-white" data-id="element-104">Compra 100% segura</h4>
            <p className="text-sm text-gray-400" data-id="element-105">Tus datos están protegidos.</p>
          </div>
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-106">
            <Zap className="w-8 h-8 text-celeste mb-2" data-id="element-107" />
            <h4 className="font-bold text-lg text-white" data-id="element-108">Acceso inmediato</h4>
            <p className="text-sm text-gray-400" data-id="element-109">
              Recibí el material al instante.
            </p>
          </div>
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-110">
            <MessageCircle className="w-8 h-8 text-celeste mb-2" data-id="element-111" />
            <h4 className="font-bold text-lg text-white" data-id="element-112">
              Soporte por WhatsApp
            </h4>
            <p className="text-sm text-gray-400" data-id="element-113">Estamos para ayudarte.</p>
          </div>
        </div>

        {/* Footer Links */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500" data-id="element-114">
          <p data-id="element-115">© 2026 Zurdo Master Pack. Todos los derechos reservados.</p>
          <div className="flex gap-6" data-id="element-116">
            <a href="#" className="hover:text-celeste transition-colors" data-id="element-117">
              Política de privacidad
            </a>
            <a href="#" className="hover:text-celeste transition-colors" data-id="element-118">
              Términos y condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}